import { isDefaultLogoSrc } from '../../../utils/common'
import { isThemeDark } from '../../../utils/themeMode'

// In Dark the backend's default logo gives way to our theme-aware logo
export function hasMenuCompanyLogo({ collapsed, theme, uk }) {
  const expandedLogo = uk.logo?.origin
  const collapsedLogo = uk.logo_mobile?.origin

  const companyLogo = collapsed
    ? (collapsedLogo ?? expandedLogo)
    : (expandedLogo ?? collapsedLogo)

  if (!companyLogo) {
    return false
  }

  return !isThemeDark(theme) || !isDefaultLogoSrc(companyLogo)
}
